import React from 'react';
import { useSelector } from 'react-redux';
import WizardNavigation from '../WizardNavigation';
import * as actions from '../../../store/actions/index';
import Aux from '../../../hoc/Aux';
import * as modalTypes from '../../Modals/modalTypes';
import ProductSystemItemsTables from '../../Shared/ProductSystemItemsTables';

const WizardStepProductSolutions = (props) => {

  if (props.currentStep !== 'product_solution') {
    return null;
  }

  const isAuthenticated = useSelector(state => state.auth.token !== null);
  const productSystem = useSelector(state => state.wizard.selectedSteps.productSystem );

  const onSaveHandler = () => {
    return (isAuthenticated === true)? showSaveProductSystemItemsModalHandler : showCatchUnauthorizedSaveSolutionModalHandler;
  }

  const showSaveProductSystemItemsModalHandler = () => {
    return (items, calcData, calcResult) => {
      const modalProps = {open: true, formObject: {selectedSystemItems: items, calcData: calcData, calcResult: calcResult}};
      const modalType = modalTypes.MODAL_SAVE_PRODUCT_SYSTEM_ITEMS;
      return actions.showModal({ modalProps, modalType });
    }
  }

  const showCatchUnauthorizedSaveSolutionModalHandler = () => {
    return (items) => {
      const modalProps = {open: true, formObject: {selectedSystemItems: items}};
      const modalType = modalTypes.MODAL_CATCH_UNAUTHORIZED_SAVE_SOLUTION;
      return actions.showModal({ modalProps, modalType });
    }
  }

  return(
    <Aux>
      <div className="row">
        <div className="col">
          <WizardNavigation />
        </div>
      </div>
      <ProductSystemItemsTables
        selectedSteps={props.selectedSteps}
        productSystem={productSystem}
        selectedItems={[]}
        onSave={onSaveHandler()}/>
    </Aux>

 );
};

export default WizardStepProductSolutions;



// WEBPACK FOOTER //
// ./src/components/Wizard/Steps/WizardStepProductSystemItems.js